import { QSetQuestionDetails } from '@exam-management/qset-question-details';

import { useQSetReviewMainTaskQSet } from '../../providers';

export default function QSetReviewMainTaskViewQuestionSection() {
  const {
    qSetQuestion: { currentQuestion, currentQuestionNumber },
  } = useQSetReviewMainTaskQSet();
  if (!currentQuestion) {
    return null;
  }
  return (
    <QSetQuestionDetails
      question={currentQuestion}
      order={currentQuestionNumber}
      // FIXME: Uncomment when #UAT1.5 is done
      // endAdornment={
      //   <Button variant='outlined' href='#' target='_blank' startIcon={<LaunchRoundedIcon />}>
      //     Edit QID
      //   </Button>
      // }
    />
  );
}
